import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import { MetaValue, FilterOption } from 'services/apollo/investor-meta';
import { CardHeader } from 'components/card-header/CardHeader';
import LIST from 'assets/img/list.png';
import {
  useGetFilterOptionsQuery,
  useGetInvestorMetaValuesQuery,
  useInvestorMetaValuesDeleteMutation,
  useInvestorMetaValuesUpdateMutation,
} from 'services/apollo';
import { Card, CardBody, Col, Button, Loading, Row, BsSwal } from 'atoms';
import FilterOptionsItem from './FilterOptionsItem';

const FilterOptions: React.FC = () => {
  const { t } = useTranslation();
  const [investorMeta, setMeta] = useState<MetaValue[]>([]);

  const [updateMeta] = useInvestorMetaValuesUpdateMutation();
  const [deleteMeta] = useInvestorMetaValuesDeleteMutation();

  const { data, loading } = useGetFilterOptionsQuery({
    fetchPolicy: 'no-cache',
  });

  const { data: dataMeta, loading: metaLoading } = useGetInvestorMetaValuesQuery({
    fetchPolicy: 'no-cache',
  });

  const onSubmit = async (): Promise<void> => {
    if (data?.getFilterMetaKeys) {
      const keys = data.getFilterMetaKeys.map((x) => `filter_${x.key}`);
      await deleteMeta({ variables: { keys } });
    }
    await updateMeta({
      variables: { data: investorMeta.map((x) => ({ ...x, key: `filter_${x.key}` })) },
    })
      .then(() => {
        BsSwal.fire({
          title: t('Settings-Filter-Options-success-save'),
          icon: 'success',
        });
      })
      .catch((err) =>
        BsSwal.fire({
          title: err,
          icon: 'success',
        }),
      );
  };

  useEffect(() => {
    if (dataMeta?.investorMetaValues) {
      const filledFilter = dataMeta.investorMetaValues
        .filter((x) => x.key.slice(0, 7) === 'filter_')
        .map((x) => ({
          value: x.value,
          key: x.key.slice(7),
        }));
      if (filledFilter.length) {
        setMeta(filledFilter);
      }
    }
  }, [dataMeta]);

  if (loading || metaLoading) {
    return <Loading />;
  }

  if (!data || !data.getFilterMetaKeys.length) {
    return <></>;
  }
  const metaKeys: { [x: string]: FilterOption[] } = {};

  const { getFilterMetaKeys } = data;

  const sorted = [...getFilterMetaKeys].sort((a, b) => a.order - b.order);

  sorted.forEach((key) => {
    const category = key.categoryKey ?? '';
    if (!metaKeys[category]) {
      metaKeys[category] = [];
    }
    metaKeys[category].push(key);
  });

  return (
    <Card>
      <CardHeader
        text={t('Settings-Filter-Options-title')}
        caption={t('Settings-Filter-Options-description')}
        imgSrc={LIST}
      />
      <CardBody>
        <Row>
          {Object.keys(metaKeys).map((category) => (
            <Col md={3} key={category}>
              <Label>
                <b>{category}</b>
              </Label>
              {metaKeys[category].map((item) => (
                <FilterOptionsItem key={item.key} item={item} values={investorMeta} update={(next) => setMeta(next)} />
              ))}
            </Col>
          ))}
        </Row>
        <Button onClick={onSubmit}>{t('Settings-Filter-Options-save')}</Button>
      </CardBody>
    </Card>
  );
};

export default FilterOptions;
